var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useEffect, useRef } from 'react';
import { useController } from 'react-hook-form';
import classNames from 'classnames';
import Error from '../Error';
import Label from '../Label';
import Instruction from '../Instruction';
var classes = {
    input: {
        base: 'rounded-md border border-gray-300 px-4 py-[14px] text-base transition-colors focus:border-brand-dark focus:outline-none placeholder-gray-500',
        error: 'border-alert-danger focus:border-alert-danger',
    },
    max: 'text-xs text-gray-500',
};
var TextArea = function (_a) {
    var label = _a.label, name = _a.name, className = _a.className, placeholder = _a.placeholder, control = _a.control, _b = _a.defaultValue, defaultValue = _b === void 0 ? '' : _b, _c = _a.required, required = _c === void 0 ? false : _c, instructions = _a.instructions, _d = _a.max, max = _d === void 0 ? undefined : _d, _e = _a.rows, rows = _e === void 0 ? 4 : _e, _f = _a.autoResize, autoResize = _f === void 0 ? false : _f;
    var _g = useController({ name: name, control: control, defaultValue: defaultValue }), _h = _g.field, ref = _h.ref, inputProps = __rest(_h, ["ref"]), fieldState = _g.fieldState;
    var textareaRef = useRef(null);
    useEffect(function () {
        if (autoResize && textareaRef.current) {
            var scrollHeight = textareaRef.current.scrollHeight;
            textareaRef.current.style.height = scrollHeight + 2 + 'px';
        }
    }, [inputProps]);
    return (<div className={classNames('flex w-full flex-col', className)}>
      {label && <Label label={label} htmlFor={name} required={required}/>}
      {instructions && <Instruction instruction={instructions}/>}
      <textarea rows={rows} maxLength={max} className={classNames(classes.input.base, fieldState.error && classes.input.error)} placeholder={placeholder} aria-invalid={!!fieldState.error} ref={function (e) {
            ref(e);
            textareaRef.current = e;
        }} {...inputProps}/>
      {max && (<div className="mt-2 flex justify-between">
          <span className={classes.max}>
            Maximum {max} caractère{max > 1 && 's'}
          </span>
          <span className={classes.max}>
            {inputProps.value.length} / {max}
          </span>
        </div>)}

      {fieldState.error && <Error message={fieldState.error.message}/>}
    </div>);
};
export default TextArea;
